import { render, staticRenderFns } from "./deporder_fdle_config.vue?vue&type=template&id=2dac6174&scoped=true&"
import script from "./deporder_fdle_config.vue?vue&type=script&lang=js&"
export * from "./deporder_fdle_config.vue?vue&type=script&lang=js&"
import style0 from "./deporder_fdle_config.vue?vue&type=style&index=0&id=2dac6174&prod&lang=scss&scoped=true&"
import style1 from "./deporder_fdle_config.vue?vue&type=style&index=1&id=2dac6174&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac6174",
  null
  
)

export default component.exports